import fetch from '../utils/fetch';

export function refreshToken(token) {
  return fetch.post(`/user/api/refresh?token=${token}`);
}

